import { useEffect, useState } from 'react'

const relationLookup = {
  '1_male': 'me',
  '1_female': 'me',
  '1_unknown': 'me',
  '1-H_male': 'husband',
  '1-H_female': 'wife',
  '1-H_unknown': 'spouse',
  '1-W_male': 'husband',
  '1-W_female': 'wife',
  '1-W_unknown': 'spouse',
  '1-U_male': 'husband',
  '1-U_female': 'wife',
  '1-U_unknown': 'spouse',
  '1-S_male': 'son',
  '1-S_female': 'daughter',
  '1-S_unknown': 'child',
  '1-D_male': 'son',
  '1-D_female': 'daughter',
  '1.X_female': 'daughter',
  '1.X_male': 'son',
  '1-D_unknown': 'child',
  '1-C_male': 'son',
  '1-C_female': 'daughter',
  '1-C_unknown': 'child',
  '2_male': 'father',
  '2_female': 'mother',
  '2_unknown': 'father',
  '3_male': 'father',
  '3_female': 'mother',
  '3_unknown': 'mother',
  '4_male': 'fathers_father',
  '4_female': 'fathers_mother',
  '4_unknown': 'fathers_father',
  '5_male': 'fathers_father',
  '5_female': 'fathers_mother',
  '5_unknown': 'fathers_father',
  '6_male': 'mothers_father',
  '6_female': 'mothers_mother',
  '6_unknown': 'mothers_father',
  '7_male': 'mothers_father',
  '7_female': 'mothers_mother',
  '7_unknown': 'mothers_father',
  '8_male': 'fathers_fathers_father',
  '8_female': 'fathers_fathers_mother',
  '8_unknown': 'fathers_fathers_father',
  '9_male': 'fathers_fathers_father',
  '9_female': 'fathers_fathers_mother',
  '9_unknown': 'fathers_fathers_father',
  '10_male': 'fathers_mothers_father',
  '10_female': 'fathers_mothers_mother',
  '10_unknown': 'fathers_mothers_father',
  '11_male': 'fathers_mothers_father',
  '11_female': 'fathers_mothers_mother',
  '11_unknown': 'fathers_mothers_father',
  '12_male': 'mothers_fathers_father',
  '12_female': 'mothers_fathers_mother',
  '12_unknown': 'mothers_fathers_father',
  '13_male': 'mothers_fathers_father',
  '13_female': 'mothers_fathers_mother',
  '13_unknown': 'mothers_fathers_father',
  '14_male': 'mothers_mothers_father',
  '14_female': 'mothers_mothers_mother',
  '14_unknown': 'mothers_mothers_father',
  '15_male': 'mothers_mothers_father',
  '15_female': 'mothers_mothers_mother',
  '15_unknown': 'mothers_mothers_father',
  '16_unknown': 'wif.familylines.unknown',
}

const getTransKey = (relation) => {
  if (!relation?.gender && !relation?.genderType) {
    return relationLookup['16_unknown']
  }
  const isDescendant = typeof relation.atn === 'string' && relation.atn && relation.atn.startsWith('1.')
  const gender = relation.gender ? relation?.genderType.split('/').pop().toLowerCase() : ''
  const genKey = gender ? `_${gender}` : '_unknown'
  let relationKey = relation.atn
  if (relation.atn === '1-S') {
    if (gender === 'male') {
      relationKey = '1-H'
    } else if (gender === 'female') {
      relationKey = '1-W'
    } else {
      relationKey = '1-U' // unknown spouse
    }
  } else if (isDescendant) {
    if (gender === 'male') {
      relationKey = '1-S'
    } else if (gender === 'female') {
      relationKey = '1-D'
    } else {
      relationKey = '1-C' // unknown child
    }
  }

  return relationLookup[`${relationKey}${genKey}`]
}
// This complexity is to handle same sex couples as well as language translations
const useRelationTransKey = (relation) => {
  const [transKey, setTransKey] = useState(null)
  useEffect(() => {
    setTransKey(getTransKey(relation))
  }, [relation])

  return transKey
}

export default useRelationTransKey
